import ShortlistButton from "@Pages/Search/components/SearchListItem/components/ShortListButton";
import classes from "../GalleryCarousel.module.scss";
import { AppState } from "@Store/index";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import ShareIcon from "@Icons/ShareIcon";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import CloseIcon from "@Icons/CloseIcon";
import wrapperHOC from "@Utils/wrapperHOC";

const CarouselTitle = ({
  currentItemIndex,
  totalItemCount,
  galleryCarouselReviewSection,
  showShare = true,
  onClose,
  currentCategory,
}: any) => {
  let actualIndex = currentItemIndex;
  if (currentItemIndex > totalItemCount) {
    actualIndex = 1;
  } else if (currentItemIndex < 1) {
    actualIndex = totalItemCount;
  }
  const dispatch = useDispatch();
  const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
  const { id, data } = useSelector(
    ({ propertyPageData }: AppState) => ({
      data: propertyPageData?.data,
      id: propertyPageData?.data?.id,
    }),
    shallowEqual,
  );
  const handleCarouselHideModal = () => {
    // Do NOT call history.goBack() here — useModal (in the parent Modal
    // component) already pops the history entry it pushed when the modal
    // unmounts via its cleanup function. Calling goBack() here caused a
    // double back-navigation on Android: once from this explicit call and
    // once from useModal's cleanup, which navigated the user away from the
    // page entirely.
    if (onClose) {
      onClose();
    }
    gtagEventEmitter({
      action: `${currentCategory === "videos" ? "video" : "image"}_modal_closed`,
      category: "inventory_page",
    });

    propertyPageDispatcher.showGalleryCarousel({
      show: false,
      images: [],
      category: "",
      currentItemIndex: 0,
      showViewRoomButton: true,
    });
  };
  return (
    <div className={classes.title}>
      <div className={classes.leftContainer}>
        <div
          data-testid="property-gallery-image-back-icon"
          onClick={handleCarouselHideModal}
          role="button"
          tabIndex={0}
          className={classes.iconContainer}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleCarouselHideModal();
            }
          }}
          aria-label="close"
        >
          <CloseIcon size={12} strokeWidth="2.5" />
        </div>
      </div>

      <div data-testid="property-gallery-image-count" className={classes.titleText}>
        {actualIndex}/{totalItemCount}
      </div>
      {!galleryCarouselReviewSection ? (
        <div className={classes.iconsContainer}>
          {showShare && (
            <div
              data-testid="property-gallery-image-share-icon"
              className={classes.shareIcon}
              role="none"
              onClick={() => {
                gtagEventEmitter({
                  action: "clicked_share",
                  category: PAGE.INVENTORY,
                  label: id,
                });
                propertyPageDispatcher.showShareModal(true);
              }}
            >
              <ShareIcon fill="white" />
            </div>
          )}
          <ShortlistButton
            dataTestId="property-gallery-image-shortlist-icon"
            inventoryId={id}
            noAbosolute
            inventory={data}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default wrapperHOC(CarouselTitle, {
  componentName: "CarouselTitle-GalleryCarousel-PropertyPage",
  showForChina: true,
});
